export default __webpack_public_path__ + "static/media/white-logo.a56f9266.png";